export default "__VITE_ASSET__aac4e99c__"